module.exports = __webpack_public_path__ + "media/parallax/separated-leaves-07-9d320ede.svg";